<template>
  <div class="formModal">
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
      <h5 class="title">选手登录信息</h5>
      <el-form-item class="w-390" label="选手姓名" prop="name">
        <el-input v-model="form.name" autocomplete="off" placeholder="请输入选手姓名"></el-input>
      </el-form-item>
      <el-form-item class="w-390" label="竞赛编号" prop="identityValue">
        <el-input v-model="form.identityValue" placeholder="请输入竞赛编号"></el-input>
      </el-form-item>
      <!-- <el-form-item class="passworld" label="验证码" prop="verifycode">
        <el-input v-model.trim="form.verifycode" placeholder="请输入验证码"></el-input>
        <img class="verify-code" @click="randomVerifyCode" :src="verifyCodeImg" alt="">
      </el-form-item> -->
      <el-form-item>
        <!-- <p class="error-msg">{{ errorMsg }}</p> -->
      </el-form-item>
      <el-form-item class="login-btn" label-width="0">
        <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {Form, FormItem, Button, Input } from 'element-ui'
import { mapActions } from 'vuex'
import { getNocUserInfo, createVerifyCode } from '@/services/user';
import _ from 'lodash'
export default{
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElButton: Button,
    ElInput: Input,
  },
  data(){
    var checkName = (rule, value, callback) => {
      // const reg = /[0-9]/
      if(!value) {
        callback(new Error('请输入选手姓名'))
      }
      // else if(reg.test(value)) {
      //   callback(new Error('不允许填写数字'))
      // }
      else if(value.length > 50 || value.length < 2) {
        callback(new Error('输入范围2-50字'))
      } else {
        callback()
      }
    }
    return{
      verifyCodeImg: '',
      errorMsg: '暂未查询到报名信息，请稍后再试或前往NOC官网咨询',
      form: {
        name: '',
        identityValue: '',
        verifycode: ''
      },
      rules: {
        name: [{validator: checkName, trigger: 'blur', required: true}],
        identityValue: [{required: true, trigger: 'blur', message: '请输入竞赛编号'}],
          verifycode: [{required: true, trigger: 'blur', message: '验证码不能为空'},
          {
            validator: (rule, value, callback) => {
              if(!value) {
                callback(new Error('验证码不能为空'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }],
      }
    }
  },
  mounted() {
    // this.randomVerifyCode()
  },
  methods: {
    ...mapActions(['saveUserInfo']),
    submitForm(form) {
      this.$refs[form].validate(async valid => {
        if(!valid) return;
        try {
          const params = {
            competitorOne: (this.form.name + '').trim(),
            // id: this.$route.query.id || '',
            // verifycode: this.form.verifycode,
            compCode: this.form.identityValue.trim()
          }
          if(!params.id) {
            delete params.id
          }
          const loginRes = await getNocUserInfo(params)
          this.errMsg = '';
          this.saveUserInfo(loginRes.data)
          if(this.$route.query.id) {
            this.$router.push({
              path: '/',
              query: {id:this.$route.query.id}
            })
          } else {
            this.$router.push({
              path: '/'
            })
          }
        } catch(e){
          if(e && e.status == 403) {
            this.errMsg = '当前手机号与NOC官网报名时的填写不一致', '请重新输入，否选手将无法参加比赛。';
          } else {
            let message = (e && e.data && e.data.message) || '未查询到该学员信息，请确认后重试'
            this.$elMessage({
              message: message,
              type: 'error'
            });
          }
        }
      })
    },
    randomVerifyCode:_.throttle(async function() {
      const res = await createVerifyCode()
      this.verifyCodeImg = window.URL.createObjectURL(res)
      this.form.verifycode = ''
    }, 700),
  }
}
</script>
<style lang="less" scoped>
.formModal{
  border-radius: 10px;
  background: #fff;
  padding-top: 22px;
  display: flex;
  justify-content: center;
}
/deep/ .w-390{
  width: 390px;
  .el-input__inner{
    width: 280px;
  }
  .el-form-item__error{
    left: 8px
  }
}

/deep/ .login-btn{
  .el-button{
    width: 110px;
    background: #0776d1
  }
}
/deep/ .passworld {
  margin-left: 5px;
  margin-bottom: 0;
  .el-form-item__content {
    padding-right: 120px;
    position: relative;
  }
  .verify-code {
    position: absolute;
    width: 100px!important;
    right: 16px;
    height: 36px;
    top: 2px
  }
}
.title{
  text-align:center;
  margin: 0;
  margin-bottom: 20px;
  font-size: 16px;
}
.error-msg {
  font-size: 12px;
  padding: 0;
  margin: 0;
  margin: 4px 0;
  color: #F56C6C;
  line-height: 1;
}
</style>